<template>
  <div v-if="hasValidUserData">
    <div class="pl-8 pr-8 min-h-screem">
      <DataTable :key="currentStatus" :items="tasks" :countTaskByProcess="countTaskByProcess" :userdata="userdata"
        :loading="loading" @update:status="handleStatusUpdate" :hasError="false"/>
    </div>
  </div>
  <div v-else class="flex items-center justify-center min-h-screen bg-gradient-to-r from-gray-400 to-gray-50">
    <div class="text-center p-8 bg-white rounded-lg shadow-2xl max-w-lg mx-auto">
      <div class="mb-8">
        <h1 class="text-9xl font-bold gradient-text">404</h1>
      </div>
      <div class="space-y-4">
        <h2 class="text-3xl font-bold text-gray-800">¡Página no encontrada!</h2>
        <p class="text-gray-600 text-lg">
          Lo sentimos, pero parece que el parámetro userdata no está presente en la URL.
        </p>
        <div class="mt-8">
          <p class="text-sm text-gray-500 mb-4">
            Asegúrate de incluir el parámetro userdata en la URL:
          </p>
          <code class="bg-gray-100 p-3 rounded-lg text-sm text-gray-700 block">
            http://sitio.com?userdata=userdata_valido
          </code>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import DataTable from '@/components/DataTable.vue';
import ApiService from '@/services/ApiService'

const route = useRoute();
const hasValidUserData = ref(false);
const userdata = ref('');
const service = new ApiService()
const tasks = service.getTasks()
const countTaskByProcess = service.getCountTaskByProcess()
const loading = service.getLoadingState()
const currentStatus = ref('Pending');

/*
Carga los datos cuando se cambian los filtros entre pendiente y finalizar. 
*/
const handleStatusUpdate = async (newStatus: string) => {
    if (newStatus !== currentStatus.value) {
    currentStatus.value = newStatus;

    const userdataParam2 = route.query.UserData as string;
    const userdataParam = userdataParam2.replace(/ /g, '+');

    await service.fetchTaskNetApi(userdataParam, newStatus);

    //Para pruebas de forma local. 
    //console.log("HomeView: " + encodeURIComponent(userdata.value));
    //await service.fetchTasksOffline(userdata.value, newStatus);
  }
}

/*
Carga los datos cuando entra por primera vez a la página.  
O cuando se recarga la misma. 
*/
onMounted(async () => {
  const userdataParam2 = route.query.UserData as string;
  const userdataParam = userdataParam2.replace(/ /g, '+');

  hasValidUserData.value = Boolean(userdataParam && userdataParam !== '');

  if (hasValidUserData.value) {
    userdata.value = userdataParam;
    try {
      await service.fetchTaskNetApi(userdataParam, currentStatus.value);
      await service.fetchCountOfTasksByProcess(userdataParam, 'Finished');

      //Para pruebas de forma local. 
      //await service.fetchTasksOffline2();

    } catch (error) {
      console.error('Error loading tasks:', error);
    }
  }
})
</script>

<style scoped>
.gradient-text {
  background: linear-gradient(90deg, #45a4c9 0%, #6baa19 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
</style>